import React from "react";

const TermsAndConditions = () => (
  <div className="p-60 max-w-4xl mx-auto">
    <h1 className="text-3xl font-bold mb-4">Terms & Conditions</h1>
    <p>Effective Date: July 26, 2025</p>

    <h2 className="text-xl font-semibold mt-6">1. Acceptance of Terms</h2>
    <p>By using our services, you agree to be bound by the following terms.</p>

    <h2 className="text-xl font-semibold mt-4">2. Account Responsibility</h2>
    <p>
      Users must provide accurate details and are responsible for account
      security.
    </p>

    <h2 className="text-xl font-semibold mt-4">3. Payment Terms</h2>
    <p>
      All payments are processed via Razorpay. A 2% transaction fee applies.
    </p>

    <h2 className="text-xl font-semibold mt-4">4. Service Availability</h2>
    <p>
      We aim for 99.9% uptime. Downtime beyond 2 hours/month will be notified.
    </p>

    <h2 className="text-xl font-semibold mt-4">5. Contact</h2>
    <p>For queries, contact us at +919662211365.</p>
  </div>
);

export default TermsAndConditions;
